module.exports = __webpack_public_path__ + "img/svg.c6b2905b.png";